// extracted by mini-css-extract-plugin
export default {"zoomexample":"zoomexample_f29ca03fcd28dccf5c8c","image":"image_a07a83f6f24e125dd787","message":"message_d59785f6e3fcfe8b75b5"};